import React from 'react';
import { Box } from '@mui/material';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{ minHeight: '100vh', background: 'var(--game-page)' }}>
    {children}
  </Box>
);

export default Layout;
